import { VIEWER_SET_SHOW_CONFIRM_PATIENT_INFO_MODAL } from '../actions';

export default function setShowConfirmPatientInfoModal(show) {
  return {
    type: VIEWER_SET_SHOW_CONFIRM_PATIENT_INFO_MODAL,
    show,
  };
}
